import React, { useState } from "react";
import { Button, Input, Modal, Space, Typography, Tag, message, Divider } from "antd";
import { ShareAltOutlined, TwitterSquareFilled, FacebookFilled, TwitterOutlined, FacebookOutlined } from '@ant-design/icons'


export default function TitleShare(props) {

    const { eisbn = "", title = "", isbn = "" } = props;


    const url = "https://bookmanager.com/item/" + eisbn;



    const CopyButton = (props) => {
        const { path = "" } = props
        const [copied, setCopied] = useState(false);

        const copyToClipboard = (_str) => {
            if (!navigator.clipboard) {
                message.error("Can't copy");
                return;
            }
            navigator.clipboard.writeText(path);
            setCopied(true);
            setTimeout(() => {
                setCopied(false)
            }, 1000);
        }

        return (<Button style={{"width" : "100px"}}  onClick={(e) => copyToClipboard(e)} type={(copied ? "default" : "primary")}>{(copied) ? "Copied" : "Copy"}</Button>);

    }

    const [visible, setVisible] = useState(false);
    const drawModal = () => {
        return (
            <>
                <Modal destroyOnClose footer={null} onCancel={() => setVisible(false)} visible={visible}>
                    <Typography.Title level={5}>Share</Typography.Title>
                    <Typography.Paragraph>To share this title, copy this link (e.g. Ctrl-C) and then paste it into an email.</Typography.Paragraph>

                    
                        <Input style={{"width" : "100%" }} defaultValue={url} />
          
                    
                    <div className="shim" /><div className="shim" /><div className="shim" />
                  



{/* 
                    <div className="shim" /><div className="shim" /><div className="shim" />
                    <Typography.Paragraph>Share on social media</Typography.Paragraph> */}

                    {/* <Space size={5}>
                        <a target="_blank" rel="noopener noreferrer" href={"https://twitter.com/share?url=" + url}><Button type="text" icon={<XIcon style={{ "fontSize": "32px", "color": "#000" }} />} /></a>
                        <a target="_blank" rel="noopener noreferrer" href={"https://www.facebook.com/sharer/sharer.php?u=" + url}><Button type="text" icon={<FacebookFilled style={{ "fontSize": "32px", "color": "#4267B2" }} />} /></a>
                    </Space> */}
                    <Divider style={{ "margin": "15px 0px" }} />



                    <div style={{ "float": "right" }}>
                        <Space>
                            
                            <Button onClick={(e) => setVisible(false)}>Cancel</Button>
                                          <CopyButton path={url} />
                        </Space>
                    </div>
                    <br clear="all" />
                </Modal>
            </>
        )
    }


    return (
        <>
            {drawModal()}
            <Button onClick={() => setVisible(true)} block size="small" className="mini-btn" ><small>Share</small></Button>
        </>
    )
}